/**
 * Headboard Cart Handler
 * Adds main product + headboard height addon as separate line items
 * Height addon is styled as sub-item in cart template
 */
(function () {
    'use strict';

    var form = document.getElementById('headboard-product-form');
    if (!form) return;

    // Skip on framebed template
    if (document.getElementById('mattress-products-data')) return;

    var ADDON_HANDLES = {
        '60': 'headboard-height-60',
        '70': 'headboard-height-70',
        '54': null
    };

    setTimeout(function () {
        var btn = document.getElementById('headboard-add-to-cart-btn');
        if (btn) btn.addEventListener('click', handleAddToCart, true);

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleAddToCart(e);
        }, true);
    }, 100);

    function handleAddToCart(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = document.getElementById('headboard-add-to-cart-btn');
        var originalText = btn ? btn.innerHTML : '';
        if (btn) { btn.innerHTML = '<span>Adding...</span>'; btn.disabled = true; }

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity')) || 1;

        // Get selected headboard size
        var sizeInput = document.querySelector('input[name="properties[Headboard Size]"]:checked');
        var sizeValue = sizeInput ? sizeInput.value : '54"';
        var sizeMatch = sizeValue.match(/\d+/);
        var sizeNumber = sizeMatch ? sizeMatch[0] : '54';

        // Collect form properties
        var properties = {};
        for (var pair of formData.entries()) {
            if (pair[0].startsWith('properties[')) {
                var name = pair[0].replace('properties[', '').replace(']', '');
                if (name !== '_price_addon' && pair[1] && pair[1].trim() !== '') {
                    properties[name] = pair[1];
                }
            }
        }

        var addonHandle = ADDON_HANDLES[sizeNumber];

        if (addonHandle) {
            // Fetch addon product to get variant ID and price
            fetch('/products/' + addonHandle + '.js')
                .then(function (res) {
                    if (!res.ok) throw new Error('Addon not found');
                    return res.json();
                })
                .then(function (product) {
                    var addonVariant = product.variants[0];
                    var formatted = '\u00a3' + (addonVariant.price / 100).toFixed(2);
                    var currentSize = properties['Headboard Size'] || sizeNumber + '"';
                    properties['Headboard Size'] = currentSize + ' (+' + formatted + ')';

                    // Add both items: main product + addon
                    var items = [
                        { id: parseInt(variantId), quantity: quantity, properties: properties },
                        { id: addonVariant.id, quantity: quantity, properties: { 'Addon For': 'Headboard' } }
                    ];

                    return fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: items })
                    });
                })
                .then(function (res) {
                    if (!res.ok) throw new Error('Failed to add to cart');
                    window.location.href = '/cart';
                })
                .catch(function () {
                    alert('Error adding to cart. Please try again.');
                    if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
                });
        } else {
            // No addon needed (54")
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity, properties: properties }] })
            })
                .then(function (res) {
                    if (!res.ok) throw new Error('Failed to add to cart');
                    window.location.href = '/cart';
                })
                .catch(function () {
                    alert('Error adding to cart. Please try again.');
                    if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
                });
        }
    }
})();
